export enum Profile {
    Sponsor = 0,
    Admin = 1,
    Partner = 2,
    Lawyer = 3,
    SuperUser = 4 // TODO remove after development
}
